const EXTERNAL_LINK_MODAL_ELEMENT_ID = "external-link-warning-modal";
export {
  EXTERNAL_LINK_MODAL_ELEMENT_ID
};
